/**
 * @ngdoc directive
 * @name directiveHyphenation
 * @restrict A
 *
 * @description
 * Directive hyphenated text
 */
export default function () {
    return {
        restrict: 'A', // Only attribute name can be used for directive definition
        link: (scope, element) => {
            $(element).hyphenate('en-us');
        }
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/hyphenation.js